import { frontendURL } from '../../../helper/URLHelper';
import CanalProCredentialsIndex from './pages/CanalProCredentialsIndex.vue';
import CanalProAccountsIndex from './pages/CanalProAccountsIndex.vue';
import CanalProListingsIndex from './pages/CanalProListingsIndex.vue';
import CanalProListingForm from './pages/CanalProListingForm.vue';

const manageMeta = { permissions: ['administrator'] };
const publishingMeta = { permissions: ['administrator', 'agent'] };

export const routes = [
  {
    path: frontendURL('accounts/:accountId/canalpro/credenciais'),
    name: 'canalpro_credentials_index',
    component: CanalProCredentialsIndex,
    meta: manageMeta,
  },
  {
    path: frontendURL('accounts/:accountId/canalpro/contas'),
    name: 'canalpro_accounts_index',
    component: CanalProAccountsIndex,
    meta: manageMeta,
  },
  {
    path: frontendURL('accounts/:accountId/canalpro/anuncios'),
    name: 'canalpro_listings_index',
    component: CanalProListingsIndex,
    meta: publishingMeta,
  },
  {
    path: frontendURL('accounts/:accountId/canalpro/anuncios/novo'),
    name: 'canalpro_listing_new',
    component: CanalProListingForm,
    meta: publishingMeta,
  },
  {
    path: frontendURL('accounts/:accountId/canalpro/anuncios/:id/editar'),
    name: 'canalpro_listing_edit',
    component: CanalProListingForm,
    meta: publishingMeta,
  },
];
